import {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { AppContext } from "../AppContext";
import { lerp } from "../utils/genericUtils";

const UserImage = ({ targetUser = null, style = {} }) => {
  const { user } = useContext(AppContext);
  const divRef = useRef(null);
  const [styleSize, setStyleSize] = useState({ display: "none" });

  const getUser = () => (targetUser ? targetUser : user);

  const setStyle = () => {
    let styleSize = {};
    if (divRef.current) {
      let fontSize = parseFloat(
        window.getComputedStyle(divRef.current).fontSize
      );

      const mul = lerp(3, 2, fontSize / 16);
      fontSize *= mul;
      styleSize = {
        ...style,
        ...{
          width: fontSize,
          height: fontSize,
        },
      };
    } else {
      styleSize = {
        display: "none",
      };
    }
    setStyleSize(styleSize);
  };

  useEffect(() => {
    setStyle();
  }, []);

  return (
    <div ref={divRef} className="user_img" style={styleSize}>
      {getUser().first_name[0].toUpperCase() +
        getUser().last_name[0].toUpperCase()}
    </div>
  );
};

export default UserImage;
